import {
	DpCatalogEntryCarouselHeaderButtonsFrameSX,
	DpCatalogEntryCarouselHeaderContentSX,
} from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader/style/main';
import {
	cardSkeletonSearchContainerMapper,
	CatalogEntryRecommendation,
} from '@/components/content/CatalogEntryRecommendation';
import { CatalogEntryCarouselSearch } from '@/components/content/CatalogEntryRecommendation/parts/CatalogEntryCarouselSearch';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Box, Grid, Skeleton, Stack, SxProps, Theme } from '@mui/material';

interface Props {
	framesx?: SxProps<Theme>;
	onClickEntryRecommendation?: () => void;
}

enum WidgetEmsName {
	HEADER = 'DPV2_Search_Recommendation_Header_Spot',
	ENTRY_RECOMMENDATION_ONE = 'DPV2_Search_Recommendation_Hombre_Spot',
	ENTRY_RECOMMENDATION_TWO = 'DPV2_Search_Recommendation_Mujer_Spot',
}

const NUM_SKELETONS = 5;
const skeletonSlide = cardSkeletonSearchContainerMapper(
	Array.from({ length: NUM_SKELETONS }).map((_, index) => `skeleton_${index}`)
).map((slide) => slide.card);

export const HeaderNavBarContentRecommendation: React.FC<Props> = ({
	framesx,
	onClickEntryRecommendation,
}) => (
	<Stack sx={framesx}>
		<ContentRecommendation
			id={WidgetEmsName.HEADER}
			properties={{
				emsName: WidgetEmsName.HEADER,
			}}
			loadingElement={
				<Stack sx={DpCatalogEntryCarouselHeaderContentSX(2)}>
					<Skeleton variant="rounded" width="40%" height="33px" />
					<Grid sx={DpCatalogEntryCarouselHeaderButtonsFrameSX}>
						{Array.from({ length: 2 }).map((_, index) => (
							<Skeleton
								variant="rounded"
								key={`id_top_button_${index}`}
								height="44px"
								width="90px"
								sx={{
									borderRadius: '21px',
								}}
							/>
						))}
					</Grid>
				</Stack>
			}
		/>
		<CatalogEntryRecommendation
			id={WidgetEmsName.ENTRY_RECOMMENDATION_ONE}
			properties={{ emsName: WidgetEmsName.ENTRY_RECOMMENDATION_ONE }}
			loadingElement={
				<CatalogEntryCarouselSearch
					slides={skeletonSlide}
					id={WidgetEmsName.ENTRY_RECOMMENDATION_ONE}
				/>
			}
			onClick={onClickEntryRecommendation}
			isSearch
		/>
		<CatalogEntryRecommendation
			id={WidgetEmsName.ENTRY_RECOMMENDATION_TWO}
			properties={{ emsName: WidgetEmsName.ENTRY_RECOMMENDATION_TWO }}
			initialHidden
			loadingElement={<Box />}
			onClick={onClickEntryRecommendation}
			isSearch
		/>
	</Stack>
);
